import React from "react";
import { Link } from "@sscs/ui";
import styles from "./loginLayout.module.scss";

const MailToSupportLink = (): React.JSX.Element => {
  return (
    <div className={styles.help}>
      <span>
        New to <strong>Spectra Assure?</strong>{" "}
        <Link href="mailto:support@reversinglabs.com" inline>
          Create an account
        </Link>
      </span>
    </div>
  );
};

export default MailToSupportLink;
